// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

import "firebase/firestore";
import { getFirestore } from 'firebase/firestore';
import { getAuth, GoogleAuthProvider, signInWithPopup, onAuthStateChanged, setPersistence, browserLocalPersistence  } from 'firebase/auth';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/storage'; 
import { getStorage } from 'firebase/storage';
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD_NsqN5-YRgyyrxXpq3Xdc1lBHDFKfaUk",
  authDomain: "dohardthings-c111d.firebaseapp.com",
  projectId: "dohardthings-c111d",
  storageBucket: "dohardthings-c111d.firebasestorage.app",
  messagingSenderId: "886040348921",
  appId: "1:886040348921:web:de1e3daff3ecdf6e78fa28",
  measurementId: "G-W2H2940KRY"
};

// ✅ Initialize app ONCE
const app = initializeApp(firebaseConfig);

// Services
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

// Auth setup
setPersistence(auth, browserLocalPersistence);
export const provider = new GoogleAuthProvider();
export const signInWithGoogle = async () => {
  try {
    const result = await signInWithPopup(auth, provider);
    return result.user;
  } catch (error) {
    console.error("Google Sign-in Error", error);
    return null;
  }
};